var map = {
	"./alm": 98,
	"./alm.json": 98,
	"./package": 99,
	"./package.json": 99,
	"./tsconfig": 100,
	"./tsconfig.json": 100,
	"./tslint": 101,
	"./tslint.json": 101
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 431;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/monaco/languages/json/schemas ^\.\/.*$
 ** module id = 431
 ** module chunks = 0
 **/